import { render } from "./ViewAudio.vue?vue&type=template&id=b4c6e198&scoped=true"
import script from "./ViewAudio.vue?vue&type=script&lang=js"
export * from "./ViewAudio.vue?vue&type=script&lang=js"

import "./ViewAudio.vue?vue&type=style&index=0&id=b4c6e198&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4c6e198"]])

export default __exports__